module.exports = __webpack_public_path__ + "static/media/no_auth_mobile@2x.b83ea02d.png";